/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Title_2Inputs */

const en_wb_sales_title_2 = /** @type {(inputs: Wb_Sales_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Without the inbox archaeology.`)
};

const lv_wb_sales_title_2 = /** @type {(inputs: Wb_Sales_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez rakšanās pasta arhīvā.`)
};

/**
* | output |
* | --- |
* | "Without the inbox archaeology." |
*
* @param {Wb_Sales_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_title_2 = /** @type {((inputs?: Wb_Sales_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_title_2(inputs)
	return en_wb_sales_title_2(inputs)
});